import * as actionTypes from 'modules/kiosks/actionTypes';
import type { KioskStatusDetails, RequestKioskStatusSuccessAction } from 'modules/kiosks/types';
import { createReducer } from 'utils/ReduxUtils';

type KioskStatusReducer = {
  loading: boolean;
  error: boolean;
  data: KioskStatusDetails | null;
};

const initialState: KioskStatusReducer = {
  loading: false,
  error: false,
  data: null,
};

const onUpdate = (): KioskStatusReducer => ({ loading: true, error: false, data: null });

const onError = (): KioskStatusReducer => ({ loading: false, error: true, data: null });

const onSuccess = (_: KioskStatusReducer, { payload }: RequestKioskStatusSuccessAction): KioskStatusReducer => ({
  loading: false,
  error: false,
  data: payload.data,
});

export default createReducer(initialState, {
  [actionTypes.REQUEST_KIOSK_STATUS]: onUpdate,
  [actionTypes.REQUEST_KIOSK_STATUS_SUCCESS]: onSuccess,
  [actionTypes.REQUEST_KIOSK_STATUS_FAILURE]: onError,
});
